import "./Intropage.css";
import IntroText from "../Components/IntroText";

export default function Intro() {
  return (
    <div className="desktop-p-intro-margin">
      <IntroText />
    </div>
  );
}
